/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ExportJobStatusResponseDto
 */
export interface ExportJobStatusResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ExportJobStatusResponseDto
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ExportJobStatusResponseDto
     */
    'status': ExportJobStatusResponseDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ExportJobStatusResponseDto
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof ExportJobStatusResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ExportJobStatusResponseDto
     */
    'completedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportJobStatusResponseDto
     */
    'errorMessage'?: string;
}

export const ExportJobStatusResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type ExportJobStatusResponseDtoStatusEnum = typeof ExportJobStatusResponseDtoStatusEnum[keyof typeof ExportJobStatusResponseDtoStatusEnum];


